import React from 'react';

import { Trans, useTranslation } from '@lyearn/i18n';
import { Plus } from '@lyearn/icons';
import { EmptyState } from '@lyearn/molecules';
import { Stack } from '@lyearn/ui';
import routes from '@/pages/corporate/routes';
import getLinkProps from '@/utils/getLinkProps';

interface Props {
  departmentId: string;
  searchString: string;
}

function SelectScorecardEmptyState({ searchString }: Props) {
  const { t } = useTranslation();

  return (
    <Stack className="h-full w-full p-24" direction="col" justifyContent="center">
      {searchString.length ? (
        <EmptyState
          className="pb-80"
          description={
            <Trans
              i18nKey="Exercise:Creator.ScorecardNotFoundDescription"
              values={{ searchString }}
            />
          }
          title={t('Exercise:Creator.NoScorecardFound')}
        />
      ) : (
        <EmptyState
          className="pb-80"
          description={t('Exercise:Creator.NoScorecardsAvailableDescription')}
          primaryAction={{
            StartIcon: Plus,
            label: t('Exercise:Creator.CreateScorecard'),
            ...getLinkProps(routes.ScorecardCreator(), true),
          }}
          title={t('Exercise:Creator.NoScorecardsAvailable')}
        />
      )}
    </Stack>
  );
}

export default SelectScorecardEmptyState;
